import React, { Component } from 'react';
import { DatePicker, Select, Checkbox, Radio, InputNumber, Input, message, Tooltip } from 'antd';
import SearchRetrieve from '../common/SearchRetrieve.new.js';
import LimitLength from './LimitLength';
import Text from './Text';
import moment from 'moment';
import './style.less';

const { Option } = Select;
const { TextArea } = Input;
const { Group: RadioGroup } = Radio;
const { Group: CheckboxGroup } = Checkbox;

const Language = {
    zh: {
        inputPlaceholder: '请输入',
        selectPlaceholder: '请选择'
    },
    en: {
        inputPlaceholder: 'Please input ',
        selectPlaceholder: 'Please Select '
    }
};

class FormList extends Component {
    // 必填校验：由父组件调用触发
    validate = () => {
        const { columns, language = 'zh' } = this.props;
        const loopValidate = function (columns) {
            let allFieldHasValue = true;
            for (let i = 0; i < columns.length; i++) {
                const { type, children, display = true, attr, attrRules } = columns[i];
                const { name, value } = attr || {};
                const { msg, required } = attrRules || {};
                if (display) {
                    if (children) {
                        allFieldHasValue = loopValidate(children);
                        if (!allFieldHasValue) break;
                    } else if (required) {
                        if (!value || (Array.isArray(value) && !value.length)) {
                            if (type === 'inputNumber' && value !== 0) {
                                let msgInfo;
                                if (msg) {
                                    msgInfo = `${msg}!`;
                                } else {
                                    msgInfo = Language[language].inputPlaceholder + name + '!';
                                }
                                message.warning(msgInfo);
                                allFieldHasValue = false;
                            } else if (type !== 'inputNumber') {
                                let msgInfo;
                                if (msg) {
                                    msgInfo = `${msg}!`;
                                } else if (type === 'input' || type === 'textArea') {
                                    msgInfo = Language[language].inputPlaceholder + name + '!';
                                } else {
                                    msgInfo = Language[language].selectPlaceholder + name + '!';
                                }
                                message.warning(msgInfo);
                                allFieldHasValue = false;
                            }
                            if (!allFieldHasValue) break;
                        }
                    }
                }
            }
            return allFieldHasValue;
        };
        return loopValidate(columns);
    }

    handleTextAreaChange = (value, column) => {
        const { key, type, attr } = column;
        const { name, limit } = attr;
        if (limit) {
            if (value && (value.length > limit)) {
                message.warning(`${name}最大可输入${limit}！`);
                return;
            }
        }
        this.props.onChange({ value, key, type });
    }

    getDomByType = (column) => {
        const { onChange, fieldWidth = 200, language = 'zh' } = this.props;
        const { key, type, attr = {} } = column;
        const iph = Language[language].inputPlaceholder;
        const sph = Language[language].selectPlaceholder;
        switch (type) {
            case 'input': {
                const { value, style = {}, placeholder = iph } = attr;
                return (
                    <Input
                        placeholder={placeholder}
                        style={{ width: fieldWidth, ...style }}
                        value={value}
                        onChange={e => onChange({ value: e.target.value, key, type })}
                    />
                );
            }
            case 'inputNumber': {
                const { value, style = {}, placeholder = iph, min, precision, ...rest } = attr;
                const setting = {
                    ...rest,
                    min: min || 0,
                    precision: precision || 0,
                };
                return (
                    <InputNumber
                        placeholder={placeholder}
                        style={{ width: fieldWidth, ...style }}
                        value={value}
                        {...setting}
                        onChange={(value) => onChange({ value, key, type })}
                    />
                );
            }
            case 'textArea': {
                const { value, limit, style = {}, rows, placeholder = iph, ...rest } = attr;
                const setting = {
                    ...rest,
                    rows: rows || 3,
                };
                return (
                    <div>
                        <TextArea
                            style={{ width: fieldWidth, ...style }}
                            value={value}
                            placeholder={placeholder}
                            {...setting}
                            onChange={(e) => this.handleTextAreaChange(e.target.value, column)}
                        />
                        <LimitLength display={limit > 0} value={value} limit={limit} />
                    </div>
                );
            }
            case 'select': {
                const { options, value, style = {}, disabled = false, mode = '', placeholder = sph } = attr;
                let newValue = value ? String(value) : undefined;
                if (mode === 'multiple') {
                    newValue = value || [];
                }
                return (
                    <Select
                        mode={mode}
                        placeholder={placeholder}
                        style={{ width: fieldWidth, ...style }}
                        disabled={disabled}
                        value={newValue}
                        onChange={value => onChange({ value, key, type })}
                    >
                        {options.map(i =>
                            <Option key={i.value}>
                                <Tooltip placement="right" title={i.label}>
                                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{i.label}</span>
                                </Tooltip>
                            </Option>
                        )}
                    </Select>
                );
            }
            case 'radio': {
                const { options, value, style = { width: '100%' }, disabled = false } = attr;
                return (
                    <RadioGroup
                        value={value}
                        style={{ width: fieldWidth, ...style }}
                        disabled={disabled}
                        onChange={e => onChange({ value: e.target.value, key, type })}
                    >
                        {options.map(i => <Radio key={i.value} value={i.value}>{i.label}</Radio>)}
                    </RadioGroup>
                );
            }
            case 'checkBox': {
                const { options, value, style = { width: '100%' } } = attr;
                return (
                    <CheckboxGroup
                        options={options}
                        value={value}
                        style={{ width: fieldWidth, ...style }}
                        onChange={checkedValues => onChange({ value: checkedValues, key, type })}
                    />
                );
            }
            case 'datePicker': {
                const { value, style = {}, allowClear = true, placeholder = sph, ...rest } = attr;
                return (
                    <DatePicker
                        {...rest}
                        placeholder={placeholder}
                        allowClear={allowClear}
                        style={{ width: fieldWidth, ...style }}
                        value={value ? moment(value) : null}
                        onChange={(date, dateString) => onChange({ value: dateString, key, type })}
                    />
                );
            }
            case 'searchRetrieve': {
                const { value, style = {}, ...rest } = attr;
                return (
                    <SearchRetrieve
                        {...rest}
                        value={value}
                        style={{ width: fieldWidth, ...style }}
                        onChange={option => onChange({ value: option, key, type })}
                    />
                );
            }
            case 'text':
            default: {
                const { value } = attr;
                return value;
            }
        }
    }

    getFileds = (field, column) => {
        const { editable = true, colon: outColon = true } = this.props;
        const { attr, attrRules, comment, commentRules } = column;
        switch (field) {
            case 'item': {
                const { name, value } = attr || {};
                const { colon, unit, prefix, suffix, required, labelClassName = '' } = attrRules || {};
                return [
                    <div className={`${field}-left ${labelClassName}`} key={`${field}-left`}>
                        <Text asterisk={editable && required} colon={colon !== undefined ? colon : outColon}>{name}</Text>
                    </div>,
                    <div className={`${field}-right`} key={`${field}-right`}>
                        {prefix}
                        {
                            editable ?
                                this.getDomByType(column)
                                :
                                value
                        }
                        {unit ? <span style={{ marginLeft: 6 }}>{unit}</span> : ''}
                        {suffix}
                    </div>
                ];
            }
            case 'comment': {
                const { name, value } = comment || {};
                const { colon, required } = commentRules || {};
                return [
                    <div className={`${field}-left`} key={`${field}-left`}>
                        <Text asterisk={editable && required} colon={colon !== undefined ? colon : outColon}>{name}</Text>
                    </div>,
                    <div className={`${field}-right`} key={`${field}-right`}>
                        {
                            editable ?
                                <Input value={value} />
                                :
                                value
                        }
                    </div>
                ];
            }
        }
    }

    renderDom = (column) => {
        const { rowClassName = '' } = this.props;
        const { key, display = true, comment } = column;
        if (!display) {
            return null;
        }
        return (
            <div className={`flex-item ${rowClassName}`} key={key}>
                {this.getFileds('item', column)}
                {comment && this.getFileds('comment', column)}
            </div>
        );
    }

    /**
     * 将列表按层级解析
     * @param columns 字段配置列表
     */
    getContent = (columns) => {
        const result = [];
        for (let i = 0, len = columns.length; i < len; i++) {
            const { children } = columns[i];
            result.push(this.renderDom(columns[i]));
            if (children) {
                result.push(...this.getContent(children));
            }
        }
        return result;
    }

    render() {
        const { columns, className = '' } = this.props;
        return (
            <div className={`flex-list ${className}`}>
                {this.getContent(columns)}
            </div>
        );
    }
}

export default FormList;


// WEBPACK FOOTER //
// ./src/components/basicElement/FormList.new.js